import { isBeforeWithOrder, PERIOD_TYPE_SORTING_ORDER } from '@/entities/symbol/periodTypeOrder';
import type { CatalogItem } from '@/types/catalog';

import type { Row, SortingFn } from '@tanstack/react-table';

export { isBeforeWithOrder, PERIOD_TYPE_SORTING_ORDER };

export const FREQUENCY_SORTING_ORDER: Record<string, number> = {
  Daily: 1,
  Weekly: 2,
  Monthly: 3,
  Quarterly: 4,
  Annual: 5
};
export const sortAsNumber: SortingFn<CatalogItem> = (
  rowA: Row<CatalogItem>,
  rowB: Row<CatalogItem>,
  columnId: string
) => {
  return Number(rowA.getValue(columnId)) - Number(rowB.getValue(columnId));
};

export const sortByOrder = (
  rowA: Row<CatalogItem>,
  rowB: Row<CatalogItem>,
  columnId: string,
  order: Record<string, number>
) => {
  const valueA = rowA.getValue(columnId);
  const valueB = rowB.getValue(columnId);

  return isBeforeWithOrder(valueA, valueB, order);
};
export const sortAsPeriodType: SortingFn<CatalogItem> = (
  rowA: Row<CatalogItem>,
  rowB: Row<CatalogItem>,
  columnId: string
) => {
  return sortByOrder(rowA, rowB, columnId, PERIOD_TYPE_SORTING_ORDER);
};

export const sortAsFrequency: SortingFn<CatalogItem> = (
  rowA: Row<CatalogItem>,
  rowB: Row<CatalogItem>,
  columnId: string
) => {
  return sortByOrder(rowA, rowB, columnId, FREQUENCY_SORTING_ORDER);
};
